const styles = {
  root: {
    width: 260,
    height: 'auto',
  },
};

export default styles;
